module.exports = __webpack_public_path__ + "static/img/20011 (3).8a78be6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20011 (3).jpg
// module id = yJYK
// module chunks = 14